export default class{
    constructor(node,Bnode,widthF=false){
        this.x=0;
        this.y=0;
        this.getRelativePos(node,Bnode,widthF);
    }
    getRelativePos(node,Bnode,widthF){
        const posi1 = node.getBoundingClientRect();
        const posi2 = [
            window.pageXOffset + posi1.left,
            window.pageYOffset + posi1.top,
          ];
        const Bposi1=Bnode.getBoundingClientRect();
          const Bposi2 = [
            window.pageXOffset + Bposi1.left,
            window.pageYOffset + Bposi1.top,
          ]
       //   console.log(posi2,Bnode.clientHeight);
        this.y=posi2[1]-Bposi2[1];
        if(widthF==true)
        this.x=posi2[0]-Bposi2[0];
        else
        this.x=posi2[0];
    }
}